import { Component, Injectable } from '@angular/core';
// @ts-ignore
import Swal from 'sweetalert2';

export type AlertType = 'warning' | 'error' | 'success';

type AlertTwoButtons = {
  isConfirmed: true,
  isDenied: false
  value: true
} | {
  isConfirmed: false,
  isDenied: true
  value: false
}

type AlertOneButton = {
  isConfirmed: true
}

@Injectable()
export class Alerts {

  alertWithOneButton(alertType: AlertType, title: string, text: string, buttonName: string) {

    return Swal.fire<AlertOneButton>({
      title: title,
      html: text,
      icon: alertType,
      confirmButtonText: buttonName,
      allowEscapeKey: false,
      allowOutsideClick: false
    });
  }

  alertWithTwoButtons(alertType: AlertType, title: string, text: string, confirmButtonText = 'Confirmar' , denyButtonText = 'Cancelar') {

    return Swal.fire<AlertTwoButtons>({
      title: title,
      text: text,
      icon: alertType,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText,
      showDenyButton: true,
      denyButtonText,
      reverseButtons: true,
      
      customClass: {
        denyButton: "btn btn-danger01"
      },
    });
  }
}
